"use strict";
exports.__esModule = true;
exports.toInvestorsThematic = exports.toThematic = void 0;
var types_1 = require("../../types");
var THEMATIC_PRISMIC_TO_LGLP = {
    'Banque et assurance': types_1.Thematic.Bank,
    'Courrier et colis': types_1.Thematic.LetterPackage,
    'Développement territorial': types_1.Thematic.Dt,
    'Informations financières': types_1.Thematic.InformationsFinancieres,
    Innovation: types_1.Thematic.Innovation,
    Culture: types_1.Thematic.Culture,
    'Logistique urbaine': types_1.Thematic.Logistic,
    Médias: types_1.Thematic.Medias,
    Partenariats: types_1.Thematic.Partnership,
    'Ressources humaines': types_1.Thematic.HumanResource,
    'Nouveaux services': types_1.Thematic.NouveauxServices,
    Groupe: types_1.Thematic.Group,
    Numérique: types_1.Thematic.Numerique,
    Ecologie: types_1.Thematic.Ecology,
    Philatélie: types_1.Thematic.Philately
};
var toThematic = function (prismicThematic, logger) {
    return logger.toConstValue(prismicThematic, THEMATIC_PRISMIC_TO_LGLP);
};
exports.toThematic = toThematic;
var INVESTORS_THEMATIC_PRISMIC_TO_LGLP = {
    'Résultats du groupe': types_1.InvestorsThematic.Results,
    Acquisitions: types_1.InvestorsThematic.Acquisitions,
    Stratégie: types_1.InvestorsThematic.Strategy,
    Gouvernance: types_1.InvestorsThematic.Governance,
    Emissions: types_1.InvestorsThematic.Emissions,
    'Branche Services-Courrier-Colis': types_1.InvestorsThematic.BSCC,
    GeoPost: types_1.InvestorsThematic.GEOPOST,
    'La Banque Postale': types_1.InvestorsThematic.LBP,
    'CNP Assurances': types_1.InvestorsThematic.CNP,
    'Branche Grand Public et Numérique': types_1.InvestorsThematic.BGPN,
    Autres: types_1.InvestorsThematic.Other
};
var toInvestorsThematic = function (prismicInvestorThematic, logger) {
    return logger.toConstValue(prismicInvestorThematic, INVESTORS_THEMATIC_PRISMIC_TO_LGLP);
};
exports.toInvestorsThematic = toInvestorsThematic;
//# sourceMappingURL=thematic.js.map